document.addEventListener("DOMContentLoaded", () => {

    const sections = document.querySelectorAll(".premium-faq");

    sections.forEach(section => {

        const items = section.querySelectorAll(".pf2-item");

        items.forEach(item => {

            const button = item.querySelector(".pf2-question");
            const answer = item.querySelector(".pf2-answer");
            const icon = item.querySelector(".pf2-icon i");

            button.addEventListener("click", () => {

                const active = item.classList.contains("active");

                /* Close Others */

                items.forEach(other => {

                    other.classList.remove("active");

                    other.querySelector(".pf2-answer").style.maxHeight = null;

                    other.querySelector(".pf2-icon i").className =
                        "fa-solid fa-plus";

                });

                if(active) return;

                item.classList.add("active");

                answer.style.maxHeight =
                    answer.scrollHeight + "px";

                icon.className = "fa-solid fa-minus";

            });

        });

    });

});


/*==========================
Reveal Animation
===========================*/

document.addEventListener("DOMContentLoaded",()=>{

const reveal=document.querySelectorAll(".pf2-item,.pf2-left,.pf2-right");

const observer=new IntersectionObserver((entries)=>{

entries.forEach(entry=>{

if(entry.isIntersecting){

entry.target.classList.add("pf2-show");

}

});

},{threshold:.15});

reveal.forEach(el=>observer.observe(el));

});